
const Megamenu = (target) => {

  const el = {
    megamenu: target,
    menus: target.querySelectorAll("[data-menu]"),
    menuTriggers: target.querySelectorAll("[data-menu-trigger]"),
    menuSingles: target.querySelectorAll("[data-no-sub]"),
    links: target.querySelector(".megamenu__col--links"),
    scrollIndicator: target.querySelector(".megamenu__scroll-indicator"),
  };

  const method = {
    init: () => {
      method.setInitialMenu();
      setTimeout(method.toggleScrollIndicators, 10);
      el.menuTriggers.forEach((trigger) => {
        trigger.addEventListener("mouseover", method.toggleMenu);
      });
      el.menuSingles.forEach((trigger) => {
        trigger.addEventListener("mouseover", method.clearMenu);
      });
    },

    setInitialMenu: () => {
      el.menus.forEach((menu, index) => {
        if (index === 0) {
          el.menuTriggers[index].classList.add("megamenu__trigger--active");
        }
        if (index !== 0) {
          menu.style.display = "none";
        }
      });
    },

    toggleMenu: (event) => {
      const currentMenu = event.currentTarget.getAttribute("data-menu-trigger");
      el.menus.forEach((menu) => {
        if (menu.getAttribute("data-menu") === currentMenu) {
          menu.removeAttribute("style");
        } else {
          menu.style.display = "none";
        }
      });
      el.menuTriggers.forEach((trigger) => {
        trigger.classList.remove("megamenu__trigger--active");
      });
      event.currentTarget.classList.add("megamenu__trigger--active");
    },

    toggleScrollIndicators: () => {
      const wrapperHeight = el.megamenu.getBoundingClientRect().height;
      const linksHeight = el.links ? el.links.getBoundingClientRect().height : 0;
      
      if (el.scrollIndicator) {
        if (wrapperHeight > linksHeight) {
          el.scrollIndicator.classList.add("megamenu__scroll-indicator--disabled");
        } else {
          el.megamenu.addEventListener("scroll", () => {
            if (el.megamenu.firstElementChild.getBoundingClientRect().top < 0) {
              el.scrollIndicator.classList.add("megamenu__scroll-indicator--hidden");
            } else {
              el.scrollIndicator.classList.remove("megamenu__scroll-indicator--hidden");
            }
          });
        }
      }
    },

    clearMenu: () => {
      el.menuTriggers.forEach((trigger) => {
        trigger.classList.remove("megamenu__trigger--active");
      });
      el.menus.forEach((menu) => {
        menu.style.display = "none";
      });
    }
  };

  method.init();
};

export default Megamenu;
